import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge class names, with later Tailwind utilities beating earlier ones.
 *
 * Plain `clsx` would emit both `p-2` and `p-4` and leave the winner to CSS source order — which is
 * bundler-dependent, so a component's `className` override would work in dev and silently stop
 * working in a production build. `twMerge` resolves the conflict deterministically.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
